import { render, staticRenderFns } from "./COM_ProHeader.vue?vue&type=template&id=37d8ae9d&scoped=true&"
import script from "./COM_ProHeader.vue?vue&type=script&lang=js&"
export * from "./COM_ProHeader.vue?vue&type=script&lang=js&"
import style0 from "./COM_ProHeader.vue?vue&type=style&index=0&id=37d8ae9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d8ae9d",
  null
  
)

export default component.exports